import { render, staticRenderFns } from "./CardNumIndicator.vue?vue&type=template&id=16cb8c42&scoped=true"
import script from "./CardNumIndicator.vue?vue&type=script&lang=js"
export * from "./CardNumIndicator.vue?vue&type=script&lang=js"
import style0 from "./CardNumIndicator.vue?vue&type=style&index=0&id=16cb8c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb8c42",
  null
  
)

export default component.exports